import numeral from "numeral";

const showDecimalAfter = 1000000;
export const getFormattedValue = (value: number) =>
  numeral(value).format(`0${value > showDecimalAfter ? "[.]0" : ""}a`);
export const getAbbrSuffix = (value: string) => value.replace(/\d\.*/g, "").toUpperCase();
